// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/_ExplanationModal.scss
// module id = 708
// module chunks = 18 88